import * as Utils from './utils';
import $ from "jquery";
import validate from "jquery-validation";
import './jquery-validate-extra-rules';

const form = document.querySelector('.js-contact'),
    toField = document.querySelector('.js-contact-to'),
    submitBtn = document.querySelector('.js-contact-submit'),
    results = document.querySelector('.js-contact-results'),
    areaSelect = document.querySelector('.js-contact-area'),
    areaList = document.querySelector('.js-area-list'),
    rules = {
        'first_name': {
            required    : true,
            minlength   : 2
        },
        'last_name': {
            required    : true,
            minlength   : 2
        },
        'email_address': {
            required    : true,
            email       : true
        },
        'message': {
            required: true,
            minlength: 5
        },
        'consent': {
            required    : true
        }
    },
    messages = {
        'first_name': {
            required    : 'Please provide your first name',
            minlength   : 'Please provide your full first name'
        },
        'last_name': {
            required    : 'Please provide your last name',
            minlength   : 'Please provide your full last name'
        },
        'email_address': {
            required    : 'Please provide your email address',
            email       : 'Please provide a valid email address'
        },
        'message': {
            required: 'Please write your message',
            minlength:  'Please write a longer message'
        },
        'consent': {
            required    : 'You must give consent for WEC to store your details so that we can respond to your request'
        }
    },
    mapEl              = document.querySelector('.js-contact-map'),
    locations          = document.querySelectorAll('.js-contact-address'),
    mapOptionsDefault   = {
        zoom: 15,
        panControl: false,
        streetViewControl: false,
        scaleControl: true,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true
    };
    
let mapInitialZoom = true,
    markerCounter = 0,
    mapMarkers = [],
    mapCanvas,
    latlngbounds;

if (mapEl) {
    latlngbounds = new google.maps.LatLngBounds();

    // Attach change event to minsitry/area dropdown
    areaSelect.addEventListener('change', changeContactDetails);

    // Create map canvas
    // Setup correct map controls
    mapCanvas = new google.maps.Map(mapEl, mapOptionsDefault);

    // Attach listeners for zoom/bound change envets on the map
    // to limit how far in we get zoomed
    mapZoomEvents();

    // Loop over all event occassions, use lat/long or geocode address,
    // and save to markers array
    generateMapMarkers();
}

if (form) {
    // Setup form validation and submision events
    $('.js-contact').validate({
        rules           : rules,
        messages        : messages,
        errorPlacement: function($error, $el) {
            // If this is a checkbox
            if ($el.is('[type=checkbox]')) {
                // Check for a group container
                const $checkboxGroupContainer = $el.closest('.js-checkbox-container');

                if ($checkboxGroupContainer.length) {
                    return $checkboxGroupContainer.append($error);
                }
            }

            return $error.insertAfter($el);
        },
        submitHandler: function (form) {
            // Update submit button text
            submitBtn.classList.add('sending')
            submitBtn.value = 'Sending...';

            // Run Recaptcha
            grecaptcha.ready(function() {
                grecaptcha.execute('6LeL1gUaAAAAANPUy9f5xUM4RSb5j2G5vnI5O-jJ', {action: 'Submit'}).then(function(token) {
                    // Add your logic to submit to your backend server here.
                    const formData = new FormData(form);

                    formData.append('grecaptchaToken', token);
        
                    fetch(form.action, {
                        method: 'POST',
                        headers: { 
                            "X-Requested-With": "XMLHttpRequest" 
                        },
                        body: formData
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data) {
                            if (data.status == 'success') {
                                form.querySelectorAll('input:not([type="checkbox"]):not([type="submit"]), textarea').forEach(el => {
                                    el.value = '';
                                });
        
                                submitBtn.classList.add('sent');
                                submitBtn.value = 'Sent!';
        
                                // Fire an event off to Google Analytics to track this form submission
                                if (typeof ga !== "undefined") {
                                    ga('send', {
                                        hitType: 'event',
                                        eventCategory: 'Contact Form',
                                        eventAction: 'Send Message',
                                        eventLabel: areaSelect.value
                                    });
                                }
                            } else {
                                submitBtn.classList.remove('sending');
                                submitBtn.value = 'Send Message';
                            }
        
                            results.classList.add(data.status);
                            results.innerHTML = data.message;
                        } else {
                            results.innerHTML = '<p>Sorry there was a problem sending your message, please try again.</>';
                            submitBtn.classList.remove('sending');
                            submitBtn.value = 'Send Message';
                        }
                    });
                });
            });
        }
    });
}

function changeContactDetails() {
    var option = this,
        slug = option.value,
        emailAddress = areaSelect.querySelector('option:checked').dataset.email;

    // Hide currently showing contact information
    areaList.querySelector('.visible').classList.remove('visible');

    // Show selected ministry/area contact information
    document.querySelector('#' + slug).classList.add('visible');

    // Update to field in contact form with selected options value
    if (emailAddress.length) {
        toField.value = emailAddress;
    } else {
        // No email address set, let's use the general one
        toField.value = 'info@wecuk.org';
    }
}

function mapZoomEvents() {
    // This is needed to set the zoom after fitbounds,
    google.maps.event.addListener(mapCanvas, 'zoom_changed', function () {
        var zoomChangeBoundsListener =
            google.maps.event.addListener(mapCanvas, 'bounds_changed', function () {
                if (mapCanvas.getZoom() > 15 && mapInitialZoom === true) {
                    // Change max/min zoom here
                    mapCanvas.setZoom(15);
                    mapInitialZoom = false;
                }

            google.maps.event.removeListener(zoomChangeBoundsListener);
        });
    });
}

function generateMapMarkers() {
    locations.forEach(location => {
        let locationString = location.dataset.address,
            latitudeString = location.dataset.latitude,
            longitudeString = location.dataset.longitude,
            title = location.dataset.title,
            infoWindowContent = "<div class='event--map-infowindow'><h3>" + title + "</h3><p>" + locationString + "</p></div>",
            geocoder = new google.maps.Geocoder(),
            locationLatLng = false;

        // Do we have any address data to work with?
        if (latitudeString === undefined && longitudeString === undefined && locationString === undefined) {
            // We can't do anything so just continue to the next loop iteration
            return true;
        } else {
            // If we have the latitude and longitude points, lets use those
            if ((latitudeString !== undefined && latitudeString !== '') && (longitudeString !== undefined && longitudeString !== '')) {
                locationLatLng = new google.maps.LatLng(latitudeString, longitudeString);

                buildMarker(locationLatLng, title, infoWindowContent);
            } else {
                // Geocode given address
                geocoder.geocode({'address': locationString}, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        locationLatLng = results[0].geometry.location;

                        buildMarker(locationLatLng, title, infoWindowContent);
                    }
                });
            }
        }
    });
}

function buildMarker(latLng, title, infoWindowContent) {
    // Add occassionLatLng to array of marker positions
    // so we can re-use them on any resize events
    mapMarkers.push(latLng);

    // Create actuall marker on the map
    var mapMarker = new google.maps.Marker({
            position    : latLng,
            map         : mapCanvas,
            title       : title
        }),
        infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent
        });

    // Add event listener fon marker click to open info window
    google.maps.event.addListener(mapMarker, 'click', function () {
        infoWindow.open(mapCanvas, mapMarker);
    });

    // Extend the bounds of the map viewport to include this marker
    latlngbounds.extend(latLng);

    // Update marker counter by 1
    markerCounter++;

    // If we've added all the markers to our map let's set the final position and zoom level
    if (markerCounter === locations.length) {
        setMapPositionAndZoom();
    }
}

function setMapPositionAndZoom() {
    // Set the map centre point
    mapCanvas.setCenter(latlngbounds.getCenter());
    mapCanvas.fitBounds(latlngbounds);
}

function resizeMap() {
    var centreLatLng = latlngbounds.getCenter();

    google.maps.event.trigger(mapCanvas, "resize");

    mapCanvas.setOptions(mapOptionsDefault);

    // Set initial zoom flag to true as we've altered things...
    mapInitialZoom = true;

    mapCanvas.setCenter(centreLatLng);
    mapCanvas.fitBounds(latlngbounds);
}